<template>
    <span>
        <the-german :value="de"/>
        <the-english :value="en"/>
    </span>
</template>

<script>


    import TheGerman from './TheGerman'
    import TheEnglish from './TheEnglish'



    export default {
        name: 'TheLanguage',
        components: {
            TheGerman,
            TheEnglish
        },
        data() {
            return {

            }
        },
        props: {
            de: String,
            en: String
        }
    }
</script>

<style lang="scss">
    .langEN .span-inline-block .lang-en{
        display: inline-block;
    }
    .langDE .span-inline-block .lang-de{
        display: inline-block;
    }
</style>
